import { Children, isValidElement } from 'react'

export function cleanChildren(children: React.ReactNode): React.ReactNode[] {
  return Children.toArray(children).filter((child) => isValidElement(child))
}
